import api from './api';

export type EstadoCredito = 'PENDENTE' | 'APROVADO' | 'REJEITADO' | 'INELEGIVEL';

export interface CampanhaPromo {
  id: string;
  nome: string;
  activa: boolean;
  valor_cve: number;
  limite: number;
  atribuidos: number;
  /** ISO em UTC. Cabo Verde é UTC-1 todo o ano. */
  inicio_utc: string;
  fim_utc: string;
  minimo_primeiro_pagamento_cve: number;
  exige_codigo: boolean;
  codigos_validos: string[];
  recargas_contam: boolean;
  contagens: Record<EstadoCredito, number>;
  /** null quando o livro não se conseguiu ler. */
  financiado_cve: number | null;
  comprometido_cve: number;
}

export interface CreditoPromo {
  id: number;
  campanha_id: string;
  user_id: string;
  cni_normalizado: string | null;
  codigo_origem: string | null;
  pagamento_id: number | null;
  pagamento_valor_cve: number | null;
  pagamento_em: string | null;
  estado: EstadoCredito;
  motivo: string | null;
  wallet_id: string | null;
  decidido_por: string | null;
  decidido_em: string | null;
  created_at: string;
  nome: string | null;
  email: string | null;
  telefone: string | null;
  registado_em: string | null;
  cni_verificada: boolean;
}

export interface ResultadoDeteccao {
  activa: boolean;
  contasNovas: number;
  pendentes: number;
  inelegiveis: number;
  aEsperar: number;
}

export type AlteracaoCampanha = Partial<Pick<CampanhaPromo,
  'activa' | 'valor_cve' | 'limite' | 'inicio_utc' | 'fim_utc'
  | 'minimo_primeiro_pagamento_cve' | 'exige_codigo' | 'recargas_contam'>> & {
  codigos_validos?: string[];
};

const BASE = '/admin/marketing/promo-origem';

/** A API responde `{ error, code }` nos 4xx; o axios põe isso em `response.data`. */
function mensagem(e: any): string {
  return e?.response?.data?.error || e?.message || 'Erro';
}

class MarketingPromoOrigemService {
  async campanha(): Promise<CampanhaPromo> {
    try { return (await api.get(`${BASE}/campanha`)).data.data; } catch (e) { throw new Error(mensagem(e)); }
  }

  async alterarCampanha(alteracao: AlteracaoCampanha): Promise<void> {
    try { await api.put(`${BASE}/campanha`, alteracao); } catch (e) { throw new Error(mensagem(e)); }
  }

  async creditos(estado?: EstadoCredito): Promise<CreditoPromo[]> {
    try {
      return (await api.get(`${BASE}/creditos`, { params: estado ? { estado } : {} })).data.data;
    } catch (e) { throw new Error(mensagem(e)); }
  }

  async aprovar(id: number): Promise<string> {
    try { return (await api.post(`${BASE}/creditos/${id}/aprovar`)).data.message; } catch (e) { throw new Error(mensagem(e)); }
  }

  async rejeitar(id: number, motivo: string): Promise<void> {
    try { await api.post(`${BASE}/creditos/${id}/rejeitar`, { motivo }); } catch (e) { throw new Error(mensagem(e)); }
  }

  async detectar(): Promise<ResultadoDeteccao> {
    try { return (await api.post(`${BASE}/detectar`)).data.data; } catch (e) { throw new Error(mensagem(e)); }
  }

  async registarFinanciamento(valor_cve: number, referencia: string): Promise<void> {
    try { await api.post(`${BASE}/financiamento`, { valor_cve, referencia }); } catch (e) { throw new Error(mensagem(e)); }
  }
}

export default new MarketingPromoOrigemService();
